<script setup>
import { computed } from 'vue';

defineProps({
  bypassUpgradePage: {
    type: Boolean,
    default: false,
  },
});

// Subscription and usage-limit locks are disabled in this local build.
const shouldShowUpgradePage = computed(() => false);
const isAccountPaywalled = computed(() => false);

defineExpose({ shouldShowUpgradePage, isAccountPaywalled });
</script>

<template><div /></template>
